import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useDateContext } from "../../context/date.context";
import { useServerSidePagingContext } from "../../context/ssp.context";
import { useTransactionServerSideContext } from "../../context/transactionServerSide.context";
import { useUserContext } from "../../context/user.context";
import useSize from "../../hooks/useScreenSize";
import { ThreeDashLoader } from "../../shared/loaders";
import { ExportTable } from "./ExportTable";
import './table.css'

export function TransactionsTablePagination({ transactionsTableData }) {
  const {
    callFilterTransactionServer,
    totalNumberOfTransactions,
    loadingFlag,
    setRefreshButton,
    refreshButton,
    setStartDateTransactions,
    setEndDateTransactions,
  } = useTransactionServerSideContext();
  const { startDate, endDate, buttonPressed } = useDateContext();
  const { merchantId } = useUserContext();
  const { t } = useTranslation();
  const { windowSize } = useSize();
  const { initialized } = useKeycloak();

  //const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [isScreenSizeSmall, setIsScreenSizeSmall] = useState(false);

  const { currentPage, setCurrentPage } = useServerSidePagingContext();

  const transactionColumnNames = Object.getOwnPropertyNames(transactionsTableData[0] || []);

  const columns1 = transactionColumnNames.map((name) => ({
    name,
    selector: (row) => [row[name]],
    cell: (row) => <div className="font-weight-bold">{row[name]}</div>,
    sortable: true,
  }));

  const tableData = {
    columns: columns1,
    data: transactionsTableData,
  };

  const handlePageChange = (page) => {
    callFilterTransactionServer(startDate, endDate, page, perPage);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    callFilterTransactionServer(startDate, endDate, page, newPerPage);
    setPerPage(newPerPage);
  };

  // const handleRefreshTableButton = () => {
  //   setStartDateTransactions(startDate)
  //   setEndDateTransactions(endDate)
  //   setRefreshButton(true);
  //   setCurrentPage(1)
  // }

  useEffect(() => {
    if (buttonPressed || refreshButton) {
      setPerPage(10);
    }
  }, [buttonPressed, refreshButton]);

  useEffect(() => {
    setTotalRows(totalNumberOfTransactions);
  }, [totalNumberOfTransactions]);

  useEffect(() => {
    setCurrentPage(1);
  }, [merchantId]);

  const numberForTotalRows = [10, 20, 50, 100, 500, 1000, 5000, 10000];

  useEffect(() => {
    setIsScreenSizeSmall(windowSize[0] < 818 || windowSize[1] < 818);
  }, [windowSize, initialized]);

  return loadingFlag ? (
    ThreeDashLoader(t("loader.loadingTransactionData"))
  ) : (
    // DataTableExtensions => (AddOn Lib for Search & Export)
    <div>
      <ExportTable tableData={transactionsTableData}>

        {/* <Button className={isScreenSizeSmall ? "wd-40p mg-x-auto mb-2" : "wd-15p mg-x-auto mb-2"} onClick={(e) => handleRefreshTableButton(e)}>
          {t("general.refreshData")}
        </Button> */}


        {/* <DataTableExtensions {...tableData} className="float-end"> */}
        <DataTable
          className="custom-data-table"
          columns={tableData.columns}
          data={tableData.data}
          defaultSortAsc={false}
          center={true}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationDefaultPage={currentPage}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          paginationPerPage={perPage}
          highlightOnHover
          paginationRowsPerPageOptions={numberForTotalRows}
        />
        {/* </DataTableExtensions> */}
      </ExportTable>
    </div>
  );
}
